import { all } from "redux-saga/effects";
import accesoSaga from "../app/modules/Acceso/handlers/saga";
import carritoSaga from "../app/modules/Carrito/handlers/saga";

function* Saga() {
  yield all([accesoSaga(), carritoSaga()]);
}

export default Saga;
